import { render, staticRenderFns } from "./auto-validation-review-page.vue?vue&type=template&id=72f78d4e&scoped=true"
import script from "./auto-validation-review-page.vue?vue&type=script&lang=js"
export * from "./auto-validation-review-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f78d4e",
  null
  
)

export default component.exports